<template>
  <div class="ic-form__r-01">
    <FormWrapper :validator="$v.form">
     <IcFormContactEmail
        v-model="form.email"
        :withAgreement="true"
        @update:agreement="form.emailAgreement = $event"
        @update:pollAgreement="form.pollAgreement = $event"
      />
      <IcFormConnection v-model="form.connection" :minDate="minDate" :endDate="endDate" />

      <h3>Wiadomość</h3>
      <IcFormContactMessage v-model="form.message" />
      <IcFormContactFiles v-model="form.files" />      
      <IcFormAgreements v-model="form.agreement" :text="false" :header="false" :modal="true" name="agreement"
              :label="$t('label_agreement_checkbox')" content="form_agreement_k09">
      </IcFormAgreements>      
      <IcFormButtons @click="submit" :sending="isSending" :error="isError" :message="errorMessage" />
    </FormWrapper>
  </div>
</template>

<script>
import IcFormContactBase from "./Base/ContactBase";

import IcFormContactName from "./Base/Name";
import IcFormContactEmail from "./Base/Email";
import IcFormContactPhone from "./Base/Phone";
import IcFormContactAddress from "./Base/Address";
import IcFormContactBank from "./Base/Bank";
import IcFormContactMessage from "./Base/Message";
import IcFormContactFiles from "./Base/Files";
import IcFormConnection from "./Base/Connection";
import IcFormContactConnection from "./Base/Connection";
import IcFormAgreements from "./Base/Agreements";
import IcFormButtons from "./Base/Buttons";
import IcCheckbox from "@/components/ic-common/form/controls/Checkbox";
import validations from "./Validation/k_09.js";
import { Connection } from "./Model/Connection";
import moment from "moment";

export default {
  name: "IcFormContactK09",
  extends: IcFormContactBase,
  validations,
  data() {
    return {
      minDate: moment()
        .add(-1, "years")
        .format("YYYY-MM-DD"),
      endDate: moment()
        .add(1, "years")
        .format("YYYY-MM-DD"),
      form: {
        type: "k09",
        connection: new Connection(),
      }
    };
  },
  components: {
    IcFormContactName,
    IcFormContactPhone,
    IcFormContactEmail,
    IcFormContactBank,
    IcFormConnection,
    IcFormContactConnection,
    IcFormContactAddress,
    IcFormContactMessage,
    IcFormContactFiles,
    IcFormAgreements,
    IcFormButtons,
    IcCheckbox
  }
};
</script>

<style>
</style>
